<template>
  <div class="special">
    <Title :Msg="titMsg" style="margin-bottom: 20px"></Title>
    <div style="height: 150px; width: 240px; margin-top: 0px; cursor: pointer">
      <tag-cloud
        style="width: 100%; height: 100%"
        :data="Categories"
        :config="config"
        @clickTag="clickTagItem"
      ></tag-cloud>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
    computed:{
    
    titMsg:function(){
      return this.$t('DataServer.tagCloud')
    }
  },
  data() {
    return {
      config: {
        maxFont: 24,
        rotateAngleYbase: 2000,
        rotateAngleXbase: 2000,
        color: "#000",
        radius: 70,
      },


      hotTag: [
        {
          id: "05023f8da31c4b4187cc6899e2a3aec2",
          name: "大气圈",
        },
        {
          id: "0ef028e5278f4f5ca31f99f1bd22b1cc",
          name: "生物圈",
        },
        {
          id: "1a32ef04d3c548eaa6777abb46da32f2",
          name: "陆地表层",
        },
        {
          id: "2c26488325bd493687d16315fe0e5fdd",
          name: "人文因素",
        },

        {
          id: "4ed593eed91b4244969995237f5c96c5",
          name: "陆地水圈",
        },
        {
          id: "615d2c178f1a47cb8d473823e74f5386",
          name: "冰冻圈",
        },
        {
          id: "76f652df03db43349272a9aff492b065",
          name: "海洋与极地",
        },
        {
          id: "8ff29d0d35e548feb945063b34ed9c9b",
          name: "固体地区",
        },
        {
          id: "05023f8da31c4b4187cc6899e2a3aec2",
          name: "大气圈",
        },
        {
          id: "0ef028e5278f4f5ca31f99f1bd22b1cc",
          name: "生物圈",
        },
        {
          id: "1a32ef04d3c548eaa6777abb46da32f2",
          name: "陆地表层",
        },
        {
          id: "2c26488325bd493687d16315fe0e5fdd",
          name: "人文因素",
        },

        {
          id: "4ed593eed91b4244969995237f5c96c5",
          name: "陆地水圈",
        },
        {
          id: "615d2c178f1a47cb8d473823e74f5386",
          name: "冰冻圈",
        },
        {
          id: "76f652df03db43349272a9aff492b065",
          name: "海洋与极地",
        },
        {
          id: "8ff29d0d35e548feb945063b34ed9c9b",
          name: "固体地区",
        },
      ],
    };
  },
  components: {
    Title: () => import("@/components/DataServer/Statistics/Title.vue"),
    //  LabelCloud: () => import("@/components/DataServer/LabelCloud/LabelCloud.vue"),
  },
  methods: {
    clickTagItem(tag) {
      // TODO
      this.$router.push(`/dataSearch?keywords=${tag.dataId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
.special {
  display: flex;
  flex-direction: column;
  align-items: center;
  .martop {
    margin-top: 16px;
    margin-bottom: 8px;
  }
  img {
    width: 250px;
    height: 60px;
  }
}
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .special {
    display: flex;
  flex-direction: column;
  align-items: center;
  .martop {
    margin-top: 16px;
    margin-bottom: 8px;
  }
  img {
    width: 250px;
    height: 60px;
  }
}
}
</style>